import { Form, Input, InputNumber, Select, Switch } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'general_setting.quota_display_type',
  'general_setting.custom_currency_symbol',
  'general_setting.custom_currency_exchange_rate',
  'QuotaPerUnit',
  'USDExchangeRate',
  'RetryTimes',
  'DisplayTokenStatEnabled',
  'DefaultCollapseSidebar',
  'token_setting.max_user_tokens',
]

const QUOTA_TYPE_OPTIONS = [
  { label: 'USD ($)', value: 'USD' },
  { label: 'CNY (¥)', value: 'CNY' },
  { label: 'Tokens', value: 'TOKENS' },
  { label: '自定义货币', value: 'CUSTOM' },
]

export default function GeneralSection({ options }: { options: OptionsAPI }) {
  const { get, getBool, getNumber, patch } = options
  const quotaType = get('general_setting.quota_display_type', 'USD')

  const combinedRate =
    quotaType === 'USD'
      ? '1'
      : quotaType === 'CNY'
        ? get('USDExchangeRate')
        : quotaType === 'TOKENS'
          ? get('QuotaPerUnit')
          : quotaType === 'CUSTOM'
            ? get('general_setting.custom_currency_exchange_rate')
            : ''

  const onCombinedRateChange = (val: string) => {
    if (quotaType === 'CNY') patch({ USDExchangeRate: val })
    else if (quotaType === 'TOKENS') patch({ QuotaPerUnit: val })
    else if (quotaType === 'CUSTOM') patch({ 'general_setting.custom_currency_exchange_rate': val })
  }

  return (
    <SettingSectionCard title="额度与展示" subtitle="额度展示类型、接口返回与侧边栏默认状态" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="失败重试次数">
            <Input value={get('RetryTimes')} onChange={(v) => patch({ RetryTimes: v })} />
          </Form.Item>
          <Form.Item label="额度展示类型">
            <Select
              value={quotaType}
              onChange={(v) => patch({ 'general_setting.quota_display_type': v })}
              options={QUOTA_TYPE_OPTIONS}
            />
          </Form.Item>
          {quotaType !== 'USD' && (
            <Form.Item
              label={quotaType === 'TOKENS' ? '每美元对应 Token 数' : '汇率'}
              extra={quotaType === 'TOKENS' ? '内部计费精度，默认 500000，修改请谨慎' : '1 USD 换算比率'}
            >
              <Input
                prefix="1 USD = "
                suffix={quotaType === 'CNY' ? 'CNY' : quotaType === 'TOKENS' ? 'Tokens' : get('general_setting.custom_currency_symbol', '¤')}
                value={combinedRate}
                onChange={onCombinedRateChange}
              />
            </Form.Item>
          )}
          {quotaType === 'CUSTOM' && (
            <Form.Item label="自定义货币符号">
              <Input
                value={get('general_setting.custom_currency_symbol', '¤')}
                onChange={(v) => patch({ 'general_setting.custom_currency_symbol': v })}
              />
            </Form.Item>
          )}
          <Form.Item label="用户最大令牌数量">
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              value={getNumber('token_setting.max_user_tokens', 1000)}
              onChange={(v) => patch({ 'token_setting.max_user_tokens': v ?? 1000 })}
            />
          </Form.Item>
          <Form.Item label="额度接口返回令牌额度">
            <Switch checked={getBool('DisplayTokenStatEnabled')} onChange={(v) => patch({ DisplayTokenStatEnabled: v })} />
          </Form.Item>
          <Form.Item label="默认折叠侧边栏">
            <Switch checked={getBool('DefaultCollapseSidebar')} onChange={(v) => patch({ DefaultCollapseSidebar: v })} />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
